"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yellow700 = exports.yellow600 = exports.yellow500 = exports.yellow400 = exports.yellow300 = exports.shade900 = exports.shade800 = exports.shade700 = exports.shade600 = exports.shade500 = exports.shade400 = exports.shade300 = exports.shade200 = exports.shade100 = exports.shade000 = exports.red700 = exports.red600 = exports.red500 = exports.red300 = exports.purple700 = exports.purple600 = exports.purple500 = exports.purple300 = exports.pink800 = exports.pink700 = exports.pink600 = exports.pink500 = exports.pink400 = exports.pink300 = exports.green800 = exports.green700 = exports.green600 = exports.green500 = exports.green300 = exports.blue700 = exports.blue600 = exports.blue500 = exports.blue300 = exports.blue200 = void 0;
exports.blue200 = "#e8f1fc";
exports.blue300 = "#d2e3f9";
exports.blue500 = "#9cc1f3";
exports.blue600 = "#6da4ed";
exports.blue700 = "#4588e3";
exports.green300 = "#d9f2e1";
exports.green500 = "#ace3bd";
exports.green600 = "#85d69e";
exports.green700 = "#6abe84";
exports.green800 = "#2c8354";
exports.pink300 = "#ffdee2";
exports.pink400 = "#ffc8d0";
exports.pink500 = "#f39ca8";
exports.pink600 = "#dc818e";
exports.pink700 = "#cb727f";
exports.pink800 = "#b2535f";
exports.purple300 = "#dcd7f4";
exports.purple500 = "#a69ae3";
exports.purple600 = "#8474d8";
exports.purple700 = "#7363c5";
exports.red300 = "#fecdcd";
exports.red500 = "#fc9090";
exports.red600 = "#fb6060";
exports.red700 = "#e91c1c";
exports.shade000 = "#ffffff";
exports.shade100 = "#fafafa";
exports.shade200 = "#f5f5f5";
exports.shade300 = "#ececec";
exports.shade400 = "#cccccc";
exports.shade500 = "#b3b3b3";
exports.shade600 = "#737373";
exports.shade700 = "#333333";
exports.shade800 = "#222222";
exports.shade900 = "#000000";
exports.yellow300 = "#fef6cd";
exports.yellow400 = "#fbefaf";
exports.yellow500 = "#fcea88";
exports.yellow600 = "#fbe360";
exports.yellow700 = "#dfc538";